export const DISPLAY_ICON_TEST_ID = 'drawingModeDropdownDisplayIcon';

export const LABEL_ICON_TEST_ID = 'drawingModeDropdownLabelIcon';

export const TEST_ID = 'drawingModeDropdown';

export { DRAWING_MODE } from 'components/Map/constants';
